export default "__VITE_ASSET__BO98XVua__"